var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertCrossRed = function SvgAlertCrossRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.257 7.745a.832.832 0 0 0-1.178 0L10 8.823 8.924 7.745a.832.832 0 1 0-1.179 1.179L8.823 10 7.745 11.08a.832.832 0 1 0 1.179 1.178L10 11.18l1.078 1.077a.831.831 0 0 0 1.178 0 .832.832 0 0 0 0-1.178L11.18 10l1.077-1.077a.832.832 0 0 0 0-1.179Zm-2.256 8.923a6.674 6.674 0 0 1-6.666-6.667A6.674 6.674 0 0 1 10 3.335 6.674 6.674 0 0 1 16.668 10a6.675 6.675 0 0 1-6.667 6.667Zm0-15c-4.595 0-8.333 3.738-8.333 8.333 0 4.595 3.738 8.334 8.333 8.334 4.595 0 8.334-3.739 8.334-8.334S14.596 1.668 10 1.668Z",
    fill: "#D23B12"
  })));
};
export default SvgAlertCrossRed;